export default "__VITE_ASSET__C5nyHYIS__"